<template>
<div class="sos-list-pricing">
	<div class="prices">

<div class="price">

<h2>Kolkin SOS<sub>&reg;</sub></h2>

<ul>

<li>Individual License</li>

</ul>

<div class="number">

<h1>$240</h1> <span>One Time Payment</span>

</div>

<hr>
<span><i class="icon icon-check"></i>Version 3 License</span>
<span><i class="icon icon-check"></i>HIPAA Compliant Software</span>
<span><i class="icon icon-check"></i>Security Updates</span>

<button @click="$router.push({ name: 'purchase-product', params: { product: 'sos-1' } })">
                Purchase
            </button>

</div>

<div class="price">

<h2 class="team-support">Kolkin SOS<sub>&reg</sub><b>Plus</b></h2>

<p>Business License</p>

<div class="number">

<h1>$995</h1> <span>per Instance</span>

</div>

<hr>
<span><i class="icon icon-check"></i>Unlimited Users</span>
<span><i class="icon icon-check"></i>HIPAA Compliant Software</span>
<span><i class="icon icon-check"></i>Version &amp; Security Updates</span>
<span><i class="icon icon-check"></i>Team Success Manager</span>
<span><i class="icon icon-check"></i>Priority Phone & Email Support</span>
<span><i class="icon icon-check"></i>Single Sign-On (Azure/Okta)</span>


<button @click="$router.push({ name: 'purchase-product', params: { product: 'sos-2' } })">
                Purchase
            </button>

</div>

<div class="custom">

<h2>Custom</h2>

<p>Enterprise features and agreements</p>

<div class="number">

<h1> Call Us </h1>

</div>

<hr>

<span><i class="icon icon-check"></i>Service Level Agreement</span>
<span><i class="icon icon-check"></i>Business Associate Agreement</span>

<span><i class="icon icon-check"></i>EHR Integration</span>

<span><i class="icon icon-check"></i>AI / Machine Learning</span>

<button class="contact-us" @click="$router.push({ name: 'contact' })">

Contact Us

</button>

</div>
	</div>
</div>
</template>

<script>
export default {

    name: "SOSListPricing"

}
</script>
